import Vue from 'vue'
import VueRouter from 'vue-router'

//########################################
//PAGES MODULE_CORE
//########################################
import ModuleCorePageIndex from '@/views/module_core/page_index/ModuleCorePageIndex.vue'

//########################################
//PAGES MODULE_BHCPF
//########################################
import PagesDefaultHeaderModuleBhcpf from '@/views/module_addon_form_bhcpf/components/PagesDefaultHeaderModuleBhcpf.vue'
import ModuleBhcpfPageSrp from '@/views/module_addon_form_bhcpf/page_srp/ModuleBhcpfPageSrp.vue'
import ModuleBhcpfPageSrpPdf from '@/views/module_addon_form_bhcpf/page_srp_pdf/ModuleBhcpfPageSrpPdf.vue'
import ModuleBhcpfPageDetails from '@/views/module_addon_form_bhcpf/page_details/ModuleBhcpfPageDetails.vue'

//########################################
//PAGES MODULE_PRIMARYISS
//########################################
import PagesDefaultHeaderModuleIssodk from '@/views/module_addon_form_primary_iss_odk/components/PagesDefaultHeaderModuleIssodk.vue'
import ModulePrimaryIssPageSrp from '@/views/module_addon_form_primary_iss_odk/page_srp/ModulePrimaryIssPageSrp.vue'
import ModulePrimaryIssPageSrpPdf from '@/views/module_addon_form_primary_iss_odk/page_srp_pdf/ModulePrimaryIssPageSrpPdf.vue'
import ModulePrimaryIssPageDetails from '@/views/module_addon_form_primary_iss_odk/page_details/ModulePrimaryIssPageDetails.vue'

//########################################
//PAGES MODULE_NHMIS_DQA_ODK
//########################################
import PagesDefaultHeaderModuleNhmisdqaodk from '@/views/module_addon_form_nhmis_dqa_odk/components/PagesDefaultHeaderModuleNhmisdqaodk.vue'
import ModuleNhmisdqaodkPageSrp from '@/views/module_addon_form_nhmis_dqa_odk/page_srp/ModuleNhmisdqaodkPageSrp.vue'
import ModuleNhmisdqaodkPageSrpPdf from '@/views/module_addon_form_nhmis_dqa_odk/page_srp_pdf/ModuleNhmisdqaodkPageSrpPdf.vue'
import ModuleNhmisdqaodkPageDetails from '@/views/module_addon_form_nhmis_dqa_odk/page_details/ModuleNhmisdqaodkPageDetails.vue'

Vue.use(VueRouter)

const routes = [
    //########################################
    //PAGES MODULE_CORE
    //########################################
    {
        path: '/core/:username/:form_name/:form_id',
        name: 'module_core_page_index',
        components: {
            default:ModuleCorePageIndex
        }
    },
    //########################################
    //PAGES MODULE_BHCPF
    //########################################
    {
        path: '/bhcpf/srp/:username/:form_name/:form_id',
        name: 'module_bhcpf_page_srp',
        components:{
            default:ModuleBhcpfPageSrp,
            router_view_header:PagesDefaultHeaderModuleBhcpf
        }
    },
    {
        path: '/bhcpf/srp/pdf/:username/:form_name/:form_id/:submission_id',
        name: 'module_bhcpf_page_srp_pdf',
        components:{
            default:ModuleBhcpfPageSrpPdf,
            //pdf pages will have no headers
            //router_view_header:PagesDefaultHeaderModuleBhcpf
        }
    },
    {
        path: '/bhcpf/details/:username/:form_name/:form_id',
        name: 'module_bhcpf_page_details',
        components:{
            default:ModuleBhcpfPageDetails,
            router_view_header:PagesDefaultHeaderModuleBhcpf
        }
    },
    //########################################
    //PAGES MODULE_PRIMARYISS
    //########################################
    {
        path: '/primary_iss/srp/:username/:form_name/:form_id',
        name: 'module_primary_iss_page_srp',
        components:{
            default:ModulePrimaryIssPageSrp,
            router_view_header:PagesDefaultHeaderModuleIssodk
        }
    },
    {
        path: '/primary_iss/srp/pdf/:username/:form_name/:form_id/:submission_id',
        name: 'module_primary_iss_page_srp_pdf',
        components:{
            default:ModulePrimaryIssPageSrpPdf,
            //pdf pages will have no headers
            //router_view_header:PagesDefaultHeaderModuleIssodk
        }
    },
    {
        path: '/primary_iss/details/:username/:form_name/:form_id',
        name: 'module_primary_iss_page_details',
        components:{
            default:ModulePrimaryIssPageDetails,
            router_view_header:PagesDefaultHeaderModuleIssodk
        }
    },
    //########################################
    //PAGES MODULE_NHMIS_DQA_ODK
    //########################################
    {
        path: '/nhmis_dqa_odk/srp/:username/:form_name/:form_id',
        name: 'module_nhmis_dqa_odk_page_srp',
        components:{
            default:ModuleNhmisdqaodkPageSrp,
            router_view_header:PagesDefaultHeaderModuleNhmisdqaodk
        }
    },
    {
        path: '/nhmis_dqa_odk/srp/pdf/:username/:form_name/:form_id/:submission_id',
        name: 'module_nhmis_dqa_odk_page_srp_pdf',
        components:{
            default:ModuleNhmisdqaodkPageSrpPdf,
            //pdf pages will have no headers
            //router_view_header:PagesDefaultHeaderModuleNhmisdqaodk
        }
    },
    {
        path: '/nhmis_dqa_odk/details/:username/:form_name/:form_id',
        name: 'module_nhmis_dqa_odk_page_details',
        components:{
            default:ModuleNhmisdqaodkPageDetails,
            router_view_header:PagesDefaultHeaderModuleNhmisdqaodk
        }
    }
]

const router = new VueRouter({
  routes
})

export default router
